import {
    API_CODE_SUCCESS,
    API_CODE_UNAUTH,
    API_CODE_FAIL,
    API_CODE_UNREFRESH,
    APIURL,
    USER_REF_TOKEN,
    USER_TOKEN,
} from './consts';
import type { RequestParams } from './consts';
import { ElLoading } from 'element-plus';
import { useAuthStore } from '@/stores/auth';
import { refreshToken } from '@/api/user';
import { ElMessage } from 'element-plus';
import router from '@/route';
import { useUserStore } from '@/stores/user';
import { useSaveLogin } from '@/hooks/user';

export const fetchHttp = (url: string, options: RequestParams) => {
    const authStore = useAuthStore();
    let loading: any = null;
    if (options.hideLoading === false) {
        loading = ElLoading.service({
            lock: true,
            text: '加载中...',
            background: 'rgba(0, 0, 0, 0.7)',
        });
    }
    const headers = options.header || {};
    headers['Authorization'] = authStore.token || '';
    // url = `${APIURL}${url}`;
    if (options.path) {
        url = `${url}/${options.path}`;
    }
    if (options.query) {
        const queryParams = new URLSearchParams(options.query).toString();
        url = `${url}?${queryParams}`;
    }
    let body = options.body || null;
    if (options.body && options.body instanceof URLSearchParams) {
        headers['Content-Type'] =
            'application/x-www-form-urlencoded; charset=utf-8';
        body = options.body.toString();
    } else if (options.body && options.body instanceof FormData) {
        // headers['Content-Type'] = 'multipart/form-data';
    } else if (options.body && typeof options.body === 'object') {
        headers['Content-Type'] = 'application/json; charset=utf-8';
        body = JSON.stringify(options.body);
    }

    return fetch(url, {
        method: options.method || 'GET',
        headers: headers,
        body: body,
    }).then(async (r):Promise<any> => {
        if (loading) {
            loading.close();
        }
        const data = await r.json();
        if (r.status === 200 && data.code === API_CODE_UNAUTH) {
            // const refreshToken = localStorage.getItem(USER_REF_TOKEN);
            const refreshKey = authStore.refreshKey;
            if (!refreshKey) {
                throw new Error('权限过期，请重新登录');
            }
            const resData = await refreshToken({
                refresh_key: refreshKey,
                token: authStore.token,
            });
            if (resData.code === API_CODE_SUCCESS) {
                // authStore.setToken(resData.data.token, resData.data.refreshKey);
                // userStore.updateDays(resData.data.days);
                useSaveLogin(resData.data);
                // 清楚url拼接
                delete options.path;
                delete options.query;

                return fetchHttp(url, options); // 重新发起请求
            }
        } else if (r.status === 200 && data.code === API_CODE_FAIL) {
            ElMessage({
                message: data.msg,
                type: 'error',
            });
        } else if (r.status === 200 && data.code === API_CODE_UNREFRESH) {
            ElMessage({
                message: '登录过期，请重新登录',
                type: 'error',
            });
            authStore.clearToken();
            // router.replace({ path: '/login' });
            router.replace({path: '/login'})
        }
        return data;
    });
};


export const http = {
    post: (url: string, data?: any,option?: any) => {
        const options: RequestParams = {
            method: 'POST',
            hideLoading: option ? option.hideLoading : false,
            body: data || {},
        };
        return fetchHttp(url, options);
    },
    get: (url: string, data?: any, option?: any) => {
        const options: RequestParams = {
            method: 'GET',
            hideLoading: false,
            // hideLoading: true,
            query: data || {},
            ...option
        };
        return fetchHttp(url, options);
    },
};
